/**
 * Created by fers on 26.09.15.
 */

import { declareEntity } from '../fw/MetaDataHelper.ts';
import { v4 as uuidv4 } from 'uuid';

export const ORG_EVENT_ORG_ADD = "org-add";
export const ORG_EVENT_ORG_DEL = "org-del";
export const ORG_EVENT_ORG_CONFIG = "org-config";
export const ORG_EVENT_ORG_BLOCK = "org-block";
export const ORG_EVENT_ORG_UNBLOCK = "org-unblock";
export const ORG_EVENT_CHANNEL_ADD = "channel-add";
export const ORG_EVENT_CHANNEL_DEL = "channel-del";
export const ORG_EVENT_CHANNEL_ACTIVATE = "channel-activate";
export const ORG_EVENT_CHANNEL_AUTH_FIRST_FAILURE = "channel-auth-first-failure";
export const ORG_EVENT_CHANNEL_AUTH_WARNING = "channel-auth-warning";
export const ORG_EVENT_CHANNEL_INVALID = "channel-invalid";
export const ORG_EVENT_CHANNEL_UNINVALID = "channel-uninvalid";
export const ORG_EVENT_CHANNEL_CONFIG = "channel-config";
export const ORG_EVENT_CHANNEL_CHANGE_CHANNEL_DEF = "channel-change-channel-def";

export const ORG_EVENT_FLOW_ADD = "flow-add";
export const ORG_EVENT_FLOW_DEL = "flow-del";
export const ORG_EVENT_FLOW_PAUSE = "flow-pause";
export const ORG_EVENT_FLOW_UNPAUSE = "flow-unpause";
export const ORG_EVENT_FLOW_BLOCK = "flow-block";
export const ORG_EVENT_FLOW_UNBLOCK = "flow-unblock";
export const ORG_EVENT_FLOW_ACTIVATE = "flow-activate";
export const ORG_EVENT_FLOW_MOVE = "flow-move";
export const ORG_EVENT_FLOW_CONFIG = "flow-config";
export const ORG_EVENT_FLOW_CHOOSE_APP = "flow-choose-app";
export const ORG_EVENT_FLOW_BILLING_STARTED = "flow-billing-started";
export const ORG_EVENT_FLOW_BILLING_STOPPED = "flow-billing-stopped";
export const ORG_EVENT_FLOW_UPGRADED = "flow-upgraded";
export const ORG_EVENT_FLOW_UPGRADED_AUTO = "flow-upgraded-auto";
export const ORG_EVENT_FLOW_UPGRADED_DEVEL = "flow-upgraded-devel";


export const EventTypes = {
    [ORG_EVENT_ORG_ADD]: {
        name: "Organisation Created",
    },
    [ORG_EVENT_ORG_DEL]: {
        name: "Organisation Deleted",
    },
    [ORG_EVENT_ORG_CONFIG]: {
        name: "Organisation Configured",
    },
    [ORG_EVENT_ORG_BLOCK]: {
        name: "Organisation Blocked",
    },
    [ORG_EVENT_ORG_UNBLOCK]: {
        name: "Organisation Unblocked",
    },
    [ORG_EVENT_CHANNEL_ADD]: {
        name: "Application Created",
    },
    [ORG_EVENT_CHANNEL_DEL]: {
        name: "Application Deleted",
    },
    [ORG_EVENT_CHANNEL_ACTIVATE]: {
        name: "Application Activated",
        isSystemChange: true,
    },
    [ORG_EVENT_CHANNEL_AUTH_FIRST_FAILURE]: {
        name: "Application auth failed for the first time",
        isSystemChange: true,
    },
    [ORG_EVENT_CHANNEL_AUTH_WARNING]: {
        name: "Application auth warning sent",
        isSystemChange: true,
    },
    [ORG_EVENT_FLOW_ADD]: {
        name: "Flow Created",
    },
    [ORG_EVENT_FLOW_DEL]: {
        name: "Flow Deleted",
    },
    [ORG_EVENT_FLOW_PAUSE]: {
        name: "Flow Paused",
    },
    [ORG_EVENT_FLOW_UNPAUSE]: {
        name: "Flow Unpaused",
    },
    [ORG_EVENT_FLOW_BLOCK]: {
        name: "Flow Blocked",
    },
    [ORG_EVENT_FLOW_UNBLOCK]: {
        name: "Flow Unblocked",
    },
    [ORG_EVENT_FLOW_BILLING_STARTED]: {
        name: "Flow billing started",
    },
    [ORG_EVENT_FLOW_BILLING_STOPPED]: {
        name: "Flow billing stopped",
    },
    [ORG_EVENT_FLOW_ACTIVATE]: {
        name: "Flow (Re)Activated",
        isSystemChange: true,
    },
    [ORG_EVENT_FLOW_MOVE]: {
        name: "Flow moved",
        isSystemChange: true,
    },
    [ORG_EVENT_CHANNEL_INVALID]: {
        name: "Application became invalid",
        isSystemChange: true,
    },
    [ORG_EVENT_CHANNEL_UNINVALID]: {
        name: "Application stopped beeing invalid",
        isSystemChange: true,
    },
    [ORG_EVENT_CHANNEL_CONFIG]: {
        name: "Application configured",
    },
    [ORG_EVENT_FLOW_CONFIG]: {
        name: "Flow configured",
    },
    [ORG_EVENT_FLOW_CHOOSE_APP]: {
        name: "Flow changed applications",
    },
    [ORG_EVENT_FLOW_UPGRADED]: {
        name: "Flow version changed",
        isSystemChange: true,
    },
    [ORG_EVENT_FLOW_UPGRADED_DEVEL]: {
        name: "Flow version changed to 'devel'",
        isSystemChange: true,
    },
    [ORG_EVENT_FLOW_UPGRADED_AUTO]: {
        name: "Flow version changed (auto)",
        isSystemChange: true,
    },
    [ORG_EVENT_CHANNEL_CHANGE_CHANNEL_DEF]: {
        name: "Application type changed",
        isSystemChange: true,
    },
};

export default declareEntity({
    entity: "organisationEvents",
    graphQL: "OrganisationEvent",
    name: "Organisation's Events",
    dynamoPrefix: 'org',
    storageType: 'central',
    userEditable: false, // all modyfying operation
    userUpdatable: false, // allow editing
    userDeletable: false, // allow remove
    defaultOrder: [['createdAt', 'desc']],
    fields: (types) => { return {
        id: {
            name: "Organisation Event ID",
            type: "id",
            defaultValue: () => {
                return uuidv4();
            },
            primaryKey: true,
            required: true,
            userEditable: false,
        },
        instance: {
            name: "Instance",
            type: "relation",
            to: () => types['instances'],
            userEditable: false,
        },
        organisation: {
            name: "Organisation ID",
            type: "relation",
            to: () => types['organisations'],
            defaultValue: (organisation) => {
                return organisation['id'];
            },
            required: true,
            parent: true,
            hiddenCreate: true,
        },
        type: {
            name: "Type",
            type: "enum",
            values: EventTypes,
            userEditable: false,
        },
        description: {
            name: "Description",
            type: "html",
            defaultValue: "",
        },
        isSystemChange: {
            name: "System Change",
            type: "boolean",
            defaultValue: false,
            userEditable: false,
            filterable: true,
        },
        changedValues: {
            name: "Changed Values",
            type: "text",
            defaultValue: "",
        },
        channel: {
            name: "Application",
            type: "relation",
            to: () => types['channels'],
            defaultValue: (job) => {
                return job['channel_id'];
            },
        },
        flow: {
            name: "Flow",
            type: "relation",
            to: () => types['flows'],
            defaultValue: (job) => {
                return job['flow_id'];
            },
        },
        channelDef: {
            name: "Application Type",
            to: () => types['channelDefs'],
            type: "relation",
            defaultValue: (job) => {
                return job['channelDef_id'];
            },
        },
        flowDef: {
            name: "Flow Definition",
            type: "relation",
            to: () => types['flowDefs'],
            defaultValue: (job) => {
                return job['flowDef_id'];
            },
        },
		scenario: {
			name: "Scenario",
			type: "relation",
			to: () => types['scenarios'],
			defaultValue: (scenario) => {
				return scenario['scenario_id'];
			},
		},
        updatedAt: {
            name: "Updated At",
            type: "datetime",
            defaultValue: () => {
                return new Date();
            },
            userEditable: false,
        },
        createdAt: {
            name: "Created At",
            type: "datetime",
            defaultValue: () => {
                return new Date();
            },
            userEditable: false,
        },
        author: {
            name: "Created By",
            type: "relation",
            to: () => types['users'],
            userEditable: false,
        },

    }; },
    relations: (types) => { return {
    }; }
});
